module.exports = __webpack_public_path__ + "static/media/location.1d1ba7a3.svg";